import { L } from "@/i18n";

const PT_LABELS = { approved: "Aprovado", pending: "Pendente", blocked: "Bloqueado", rejected: "Rejeitado" };

const STYLES = {
  approved: ["Approved", "text-emerald-400 bg-emerald-500/10 border-emerald-500/30"],
  pending: ["Pending", "text-amber-400 bg-amber-500/10 border-amber-500/30"],
  blocked: ["Blocked", "text-rose-400 bg-rose-500/10 border-rose-500/30"],
  rejected: ["Rejected", "text-slate-400 bg-slate-500/10 border-slate-500/30"],
};

export const StatusBadge = ({ status }) => {
  const [label, cls] = STYLES[status] ?? [status, STYLES.rejected[1]];
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 font-mono text-[11px] ${cls}`}>{L(label, PT_LABELS[status])}</span>;
};
